<template>
    <div :class="['t-events-video-modal', props.class]">
        <h3 class="t-events-video-modal__title t-subtitle">{{ props.title }}</h3>
        <div v-if="props.video.indexOf('youtu') >= 0" class="t-events-video-modal__video">
            <iframe
                width="820"
                height="470"
                frameborder="0"
                allowTransparency="true"
                allowfullscreen
                :src="'https://www.youtube.com/embed/' + videoLink(props.video) + '?autoplay=1&modestbranding=1&rel=0&hl=ru&showinfo=0'"
                :srcdoc="styleIframe +
                    '<a href=https://www.youtube.com/embed/' + videoLink(props.video) + '?autoplay=1>' +
                    '<img src=https://img.youtube.com/vi/' + videoLink(props.video) + '/maxresdefault.jpg alt=DemoVideo>' +
                    '<div class=bg></div>' +
                    svgIframe +
                    '</a>'"
            ></iframe>
        </div>
        <div v-if="props.video.indexOf('vimeo') >= 0" class="t-events-video-modal__video">
            <iframe
                :src="'https://player.vimeo.com/video/' + videoLink(props.video) + '?title=0&byline=0&portrait=0&transparent=0&sidedock=0'"
                width="820"
                height="470"
                frameborder="0"
                webkitallowfullscreen
                mozallowfullscreen
                allowfullscreen
            ></iframe>
        </div>
        <div v-if="props.name" class="t-events-video-modal__name">{{ props.name }}</div>
        <div v-if="props.desc" class="t-events-video-modal__desc" v-html="props.desc"></div>
        <div v-if="props.class === '_lk'" class="t-events-video-modal__row">
            <a v-if="props.link" :href="props.link" target="_blank" class="t-events-video-modal__link">
                {{ $root.staticText.lk.linkModal }}
            </a>
            <div class="t-events-video-modal__date">
                {{ $root.staticText.lk.dateModal }} {{ props.date }}
            </div>
        </div>
    </div>
</template>

<script>
    import {mapActions} from "vuex";

    export default {
        props: ['props'],
        data() {
            return {
                styleIframe: '<style>*{padding:0;margin:0;overflow:hidden}html,body{height:100%}' +
                    'img,svg,.bg{position:absolute;width:100%;height:100%;object-fit:cover;top:0;bottom:0;margin:auto}' +
                    '.bg:hover+svg g path, svg:hover g path{fill: #00b0bd;stroke: #00b0bd;}' +
                    'svg{height: 96px;width: 96px;left: calc(50% - 48px);}' +
                    'svg g path{transition: all .3s;}' +
                    '.bg{background: linear-gradient(180deg, rgba(91, 91, 91, 0.2) 0%, rgba(91, 91, 91, 0.1) 100%)}' +
                    '</style>',
                svgIframe: '<svg width="96" height="96" viewBox="0 0 96 96" fill="none" xmlns="http://www.w3.org/2000/svg">' +
                    '<g filter="url(#filter0_d)">' +
                    '<path d="M79 40.3303C79 57.2591 65.1306 71.0004 48 71.0004C30.8694 71.0004 17 57.2591 17 40.3303C17 23.4014 30.8694 9.66016 48 9.66016C65.1306 9.66016 79 23.4014 79 40.3303Z" stroke="white" stroke-width="2"/>' +
                    '</g>' +
                    '<path d="M56.961 38.5939C58.3047 39.3617 58.3047 41.2991 56.961 42.0669L44.9923 48.9058C43.659 49.6677 42.0001 48.7049 42.0001 47.1693L42.0001 33.4915C42.0001 31.9559 43.659 30.9931 44.9923 31.755L56.961 38.5939Z" fill="white"/>' +
                    '<defs>' +
                    '<filter id="filter0_d" x="0" y="0.660156" width="96" height="95.3402" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">' +
                    '<feFlood flood-opacity="0" result="BackgroundImageFix"/>' +
                    '<feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/>' +
                    '<feOffset dy="8"/>' +
                    '<feGaussianBlur stdDeviation="8"/>' +
                    '<feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>' +
                    '<feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow"/>' +
                    '<feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow" result="shape"/>' +
                    '</filter>' +
                    '</defs>' +
                    '</svg>',
            }
        },
        methods: {
            ...mapActions('modal', ['modalClose']),
            videoLink(link) {
                let video_link = null;
                if (link.indexOf('youtu') >= 0) {
                    video_link = link.split('?v=')[1];
                    video_link = video_link.split('&')[0];
                }
                if (link.indexOf('vimeo') >= 0) {
                    let index = link.lastIndexOf('/') + 1;
                    video_link = link.substring(index, link.length);
                }
                return video_link;
            }
        }
    }
</script>

<style lang="sass">

</style>


// WEBPACK FOOTER //
// src/templates/components/base/modals/eventsVideo.vue